import { render, staticRenderFns } from "./ConfigParamsTree.vue?vue&type=template&id=04c80e42&scoped=true&"
import script from "./ConfigParamsTree.vue?vue&type=script&lang=js&"
export * from "./ConfigParamsTree.vue?vue&type=script&lang=js&"
import style0 from "./ConfigParamsTree.vue?vue&type=style&index=0&id=04c80e42&scoped=true&lang=css&"
import style1 from "./ConfigParamsTree.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c80e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c80e42')) {
      api.createRecord('04c80e42', component.options)
    } else {
      api.reload('04c80e42', component.options)
    }
    module.hot.accept("./ConfigParamsTree.vue?vue&type=template&id=04c80e42&scoped=true&", function () {
      api.rerender('04c80e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ConfigParamsTree.vue"
export default component.exports